export enum PropertyType {
    None = -1,
    SingleFamily = 0,
    Condo = 1,
    Townhouse = 2,
    Coop = 3,
    TwoToFourUnitProperty= 4,
    MultifamilyMoreThanFourUnits= 5,
    CommercialNonResidential= 6,
    MixedUseResidential= 7,
    Farm= 8,
    HomeAndBusinessCombined= 9,
    Land= 10,
    ManufacturedMobileHome=11
}
